import React from 'react';

export function getYourRightsContent(admin) {
    const adminEmployer = (admin && admin.employer) || 'GreenLight Workforce Solutions';
    const ftcUrl = admin && admin.ftc_regional_url;

    return (
        <div>
            <p>
                <span className="custom-text">
                    Para información en español, visite{' '}
                    <a href="http://www.consumerfinance.gov/learnmore" target="_blank" rel="noopener noreferrer">
                        www.consumerfinance.gov/learnmore
                    </a>{' '}
                    o escribe a la Consumer Financial Protection Bureau, 1700 G Street N.W., Washington, DC 20552.
                </span>
            </p>
            <h4>A Summary of Your Rights Under the Fair Credit Reporting Act</h4>
            <p>
                <span className="custom-text">
                    The federal Fair Credit Reporting Act (FCRA) promotes the accuracy, fairness, and privacy of information in the files of consumer reporting
                    agencies. There are many types of consumer reporting agencies, including credit bureaus and specialty agencies (such as agencies that sell
                    information about check writing histories, medical records, and rental history records). Here is a summary of your major rights under the
                    FCRA.{' '}
                    <strong>
                        For more information, including information about additional rights, go to{' '}
                        <a href="http://www.consumerfinance.gov/learnmore" target="_blank" rel="noopener noreferrer">
                            www.consumerfinance.gov/learnmore
                        </a>{' '}
                        or write to: Consumer Financial Protection Bureau, 1700 G Street N.W., Washington, DC 20552.
                    </strong>
                </span>
            </p>
            <p>
                <span className="custom-text">
                    <strong>You must be told if information in your file has been used against you.</strong> Anyone who uses a credit report or another type of
                    consumer report to deny your application for credit, insurance, or employment - or to take another adverse action against you - must tell
                    you, and must give you the name, address, and phone number of the agency that provided the information.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    <strong>You have the right to know what is in your file.</strong> You may request and obtain all the information about you in the files of a
                    consumer reporting agency (your “file disclosure”). You will be required to provide proper identification, which may include your Social
                    Security number. In many cases, the disclosure will be free. You are entitled to a free file disclosure if: - a person has taken adverse
                    action against you because of information in your credit report; - you are the victim of identify theft and place a fraud alert in your
                    file; - your file contains inaccurate information as a result of fraud; - you are on public assistance; - you are unemployed but expect to
                    apply for employment within 60 days.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    In addition, all consumers are entitled to one free disclosure every 12 months upon request from each nationwide credit bureau and from
                    nationwide specialty consumer reporting agencies. See{' '}
                    <a href="http://www.consumerfinance.gov/learnmore" target="_blank" rel="noopener noreferrer">
                        www.consumerfinance.gov/learnmore
                    </a>{' '}
                    for additional information.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    <strong>You have the right to ask for a credit score.</strong> Credit scores are numerical summaries of your credit-worthiness based on
                    information from credit bureaus. You may request a credit score from consumer reporting agencies that create scores or distribute scores
                    used in residential real property loans, but you will have to pay for it. In some mortgage transactions, you will receive credit score
                    information for free from the mortgage lender.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    <strong>You have the right to dispute incomplete or inaccurate information.</strong> If you identify information in your file that is
                    incomplete or inaccurate, and report it to the consumer reporting agency, the agency must investigate unless your dispute is frivolous. See{' '}
                    <a href="http://www.consumerfinance.gov/learnmore" target="_blank" rel="noopener noreferrer">
                        www.consumerfinance.gov/learnmore
                    </a>{' '}
                    for an explanation of dispute procedures.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    <strong>Consumer reporting agencies must correct or delete inaccurate, incomplete, or unverifiable information.</strong> Inaccurate,
                    incomplete or unverifiable information must be removed or corrected, usually within 30 days. However, a consumer reporting agency may
                    continue to report information it has verified as accurate.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    <strong>Consumer reporting agencies may not report outdated negative information.</strong> In most cases, a consumer reporting agency may
                    not report negative information that is more than seven years old, or bankruptcies that are more than 10 years old.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    <strong>Access to your file is limited.</strong> A consumer reporting agency may provide information about you only to people with a valid
                    need – usually to consider an application with a creditor, insurer, employer, landlord, or other business. The FCRA specifies those with a
                    valid need for access.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    <strong>You must give your consent for reports to be provided to employers.</strong> A consumer reporting agency may not give out
                    information about you to your employer, or a potential employer, without your written consent given to the employer. Written consent
                    generally is not required in the trucking industry. For more information, go to{' '}
                    <a href="http://www.consumerfinance.gov/learnmore" target="_blank" rel="noopener noreferrer">
                        www.consumerfinance.gov/learnmore
                    </a>.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    <strong>You may limit “prescreened” offers of credit and insurance you get based on information in your credit report.</strong> Unsolicited
                    “prescreened” offers for credit and insurance must include a toll-free phone number you can call if you choose to remove your name and
                    address from the lists these offers are based on. You may opt out with the nationwide credit bureaus at 1-888-5-OPTOUT (1-888-567-8688).
                </span>
            </p>
            <p>
                <span className="custom-text">
                    <strong>You may seek damages from violators.</strong> If a consumer reporting agency, or, in some cases, a user of consumer reports or a
                    furnisher of information to a consumer reporting agency violates the FCRA, you may be able to sue in state or federal court.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    <strong>Identity theft victims and active duty military personnel have additional rights.</strong> For more information, visit{' '}
                    <a href="http://www.consumerfinance.gov/learnmore" target="_blank" rel="noopener noreferrer">
                        www.consumerfinance.gov/learnmore
                    </a>.
                </span>
            </p>
            <p>
                <span className="custom-text">
                    <strong>
                        States may enforce the FCRA, and many states have their own consumer reporting laws. In some cases, you may have more rights under state
                        law. For more information, contact your state or local consumer protection agency or your state Attorney General. For information about
                        your federal rights, contact the{' '}
                        {ftcUrl ? (
                            <a href={ftcUrl} target="_blank" rel="noopener noreferrer">
                                FTC Regional Office for the region in which {adminEmployer} operates
                            </a>
                        ) : (
                            `FTC Regional Office for the region in which ${adminEmployer} operates`
                        )}
                        , or: Federal Trade Commission Consumer Response Center - FCRA, Washington, DC 20580, (877) 382-4357.
                    </strong>
                </span>
            </p>

            <br />
            <h4>Consumers Have The Right To Obtain A Security Freeze</h4>
            <ul>
                <li className="p-2">
                    <span className="custom-text">
                        You have a right to place a “security freeze” on your credit report, which will prohibit a consumer reporting agency from releasing
                        information in your credit report without your express authorization. The security freeze is designed to prevent credit, loans, and
                        services from being approved in your name without your consent. However, you should be aware that using a security freeze to take
                        control over who gets access to the personal and financial information in your credit report may delay, interfere with, or prohibit the
                        timely approval of any subsequent request or application you make regarding a new loan, credit, mortgage, or any other account involving
                        the extension of credit.
                    </span>
                </li>
                <li className="p-2">
                    <span className="custom-text">
                        As an alternative to a security freeze, you have the right to place an initial or extended fraud alert on your credit file at no cost.
                        An initial fraud alert is a 1-year alert that is placed on a consumer’s credit file. Upon seeing a fraud alert display on a consumer’s
                        credit file, a business is required to take steps to verify the consumer’s identity before extending new credit. If you are a victim of
                        identity theft, you are entitled to an extended fraud alert, which is a fraud alert lasting 7 years.
                    </span>
                </li>
                <li className="p-2">
                    <span className="custom-text">
                        A security freeze does not apply to a person or entity, or its affiliates, or collection agencies acting on behalf of the person or
                        entity, with which you have an existing account that requests information in your credit report for the purposes of reviewing or
                        collecting the account. Reviewing the account includes activities related to account maintenance, monitoring, credit line increases, and
                        account upgrades and enhancements.
                    </span>
                </li>
            </ul>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/employee/assets/yourRights.jsx